const GAME_COLORS = {
  wordpro: '#4CAF50',
  connectpro: '#2563eb',
  eventpro: '#ea580c',
  buildpro: '#0f766e',
  wordprofinder: '#4CAF50',
  seashroud: '#287f89',
  sevenapart: '#644a83',
  mathpro: '#996128',
};

export function createGameLinks(games, statuses, playerName = '') {
  return games.map((game) => {
    const played = statuses[game.key] === true;
    const playerParam = playerName ? `?player_name=${encodeURIComponent(playerName)}` : '';
    return {
      ...game,
      played,
      href: `${game.href}${played ? '/leaderboard' : '/'}${playerParam}`,
    };
  });
}

export function createLeaderboardHeaderLinks(gameLinks, buildStatusLink) {
  return [...gameLinks.slice(0, 3), buildStatusLink, ...gameLinks.slice(3)].map((game) => ({
    ...game,
    letter: game.label || game.letter,
    color: game.color || GAME_COLORS[game.key],
  }));
}
